import React from 'react'
import { useQuery } from '@apollo/client/react'
import {
  Grid,  Typography } from '@mui/material'
import { GET_SUBSCRIPTION_PLAN } from './queries'
import { LoadingSkeleton } from '@/housefolios-components/LoadingSkeleton'

export default function SubscriptionPlanPrice({
  subscriptionPlanId,
  planLabel,
  yearlyPrice = false,
  currencyFormat,
}) {
  const { loading, data } = useQuery(GET_SUBSCRIPTION_PLAN, {
    variables: { subscriptionPlan: subscriptionPlanId },
  })

  if (loading) return <LoadingSkeleton variant="inline" width={160} height={28} />

  const { subscriptionPlan = {} } = data || {}
  const price = yearlyPrice
    ? subscriptionPlan.price / 12 / 100
    : subscriptionPlan.price / 100

  return (
    <Grid
      container
      direction="row"
      sx={{
        justifyContent: "space-between",
        alignItems: "center"
      }}>
      <Grid>
        <Typography>{planLabel}</Typography>
      </Grid>
      <Grid>
        <Typography>
          {currencyFormat.format(price)}
          /mo
        </Typography>
      </Grid>
    </Grid>
  );
}
